export default async function ({ $auth, store }) {
    if (!$auth.loggedIn) {
        return
    }
    await store.dispatch("account/init", null, { root: true })
}
